import { useTranslation } from 'react-i18next'

import { FormikWysiwygField } from '../../Formik'
import { LISTING_FORM_FIELD_NAME_DESCRIPTION } from '../RentalPortalListing.constants'

function RentalPortalListingDescriptionField({ isLoading }) {
  const { t } = useTranslation()

  return (
    <FormikWysiwygField
      fieldComponentProps={{
        isLoading,
        label: `${t('RentalPortal.ListingFormDescriptionLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={LISTING_FORM_FIELD_NAME_DESCRIPTION}
      placeholder={t('RentalPortal.ListingFormDescriptionPlaceholderKey')}
    />
  )
}

export default RentalPortalListingDescriptionField
